import { z } from "zod";
function createApiResponseSchema(dataType) {
  return z.object({
    resultCode: z.string(),
    token: z.string().nullable(),
    reqPath: z.string(),
    statusCode: z.number().nullable(),
    resultMsg: z.string().nullable(),
    errMsg: z.string().nullable(),
    resultMap: dataType
  });
}
export {
  createApiResponseSchema
};
//# sourceMappingURL=response.js.map